/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import { Box, Flex, Link, Text } from '@bottlebooks/gatsby-theme-base/src';
import useSnipcart from '../../../useSnipcart';
import { jsx } from 'theme-ui';
import ProductSnipcartButton from '../../Shop/ProductSnipcartButton';
import { Trans } from '@lingui/macro';

/** A button to buy via Snipcart. */
export default function ProductRequestSampleWithSnipcartButton({
  product,
  ...rest
}) {
  return (
    <ProductSnipcartButton product={product} data-item-price={0} {...rest} />
  );
}

function CartText({ product }) {
  const { isItemInCart, canAddMoreProducts, openCart, maxItems } =
    useSnipcart();
  if (isItemInCart(product.productId))
    return (
      <Text variant="small" sx={{ marginLeft: 3, marginRight: 2 }}>
        <Trans>
          <Link
            onClick={() => openCart()}
            sx={{
              padding: 0,
              margin: 0,
              font: 'inherit',
              fontSize: 'inherit',
              border: 'none',
              backgroundColor: 'transparent',
              color: 'primary',
            }}
          >
            View cart
          </Link>
        </Trans>
      </Text>
    );

  // If there is no maximum, let's stop here
  if (!maxItems) return null;
  if (!canAddMoreProducts)
    return (
      <Text variant="small" sx={{ marginLeft: 3 }}>
        <Trans>
          You can request up to 12 products.{' '}
          <Link
            onClick={() => openCart()}
            sx={{
              padding: 0,
              margin: 0,
              font: 'inherit',
              fontSize: 'inherit',
              border: 'none',
              backgroundColor: 'transparent',
              color: 'primary',
            }}
          >
            Remove wines
          </Link>{' '}
          to add others.
        </Trans>
      </Text>
    );

  return null;
}

export const fragment = graphql`
  fragment bb_ProductRequestSampleWithSnipcartButton on Bottlebooks_Product {
    ...bb_ProductSnipcartButton
  }
`;

ProductRequestSampleWithSnipcartButton.fragment = gql`
  fragment ProductRequestSampleWithSnipcartButton on Product {
    ...ProductSnipcartButton
  }
  ${ProductSnipcartButton.fragment}
`;
